import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLegacyProgressBarModule as MatProgressBarModule } from '@angular/material/legacy-progress-bar';
import { LogoLoaderModule } from '@y42/core/logo-loader';
import { TableDataAgGridModule } from './components/table-data-ag-grid/table-data-ag-grid.module';
import { TableViewerComponent } from './table-viewer.component';

@NgModule({
  declarations: [TableViewerComponent],
  imports: [CommonModule, LogoLoaderModule, MatProgressBarModule, TableDataAgGridModule],
  exports: [TableViewerComponent],
})
export class TableViewerModule {}
